import React from 'react';
import { closeModal } from '../../redux/slices/modal';
import KubitModal from '../KubitModal';
import { useAppDispatch } from '../../redux/hooks';
import usePermission from '../../utils/hooks/permissionHooks';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import { ModalActions } from '../KubitModal/KubitModalUI';
import { PrimaryButton, SecondaryButton } from '../Button';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../path';

const ConfigureLumosModal = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { checkIsPermitted } = usePermission();
  const isPermittedForAdmin = checkIsPermitted({
    requiredPermissionKeys: [PermissionKey.AdminRead],
  });

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleRedirectToAdminSettings = () => {
    navigate(appRoutes.permission.settings);
    handleClose();
  };

  const handleSubmit = () => {
    dispatch(closeModal());
  };

  if (isPermittedForAdmin) {
    return (
      <KubitModal header="Setup OpenAI" onClose={handleClose} open>
        <p>
          Looks like your OpenAI account isn’t set up yet. To configure OpenAI
          features you must enable AI in Admin settings.
        </p>
        <ModalActions>
          <SecondaryButton type="button" onClick={handleClose} isOutlined>
            Cancel
          </SecondaryButton>
          <PrimaryButton type="button" onClick={handleRedirectToAdminSettings}>
            Admin Settings
          </PrimaryButton>
        </ModalActions>
      </KubitModal>
    );
  }

  return (
    <KubitModal header="Setup OpenAI" onClose={handleClose} open>
      <p>
        Looks like your OpenAI account isn’t set up yet. To start building
        cohorts or reports using natural language, contact your Kubit
        admin—they’ll help get you up and running.
      </p>
      <ModalActions>
        <SecondaryButton type="button" onClick={handleClose} isOutlined>
          Cancel
        </SecondaryButton>
        <PrimaryButton type="button" onClick={handleSubmit}>
          Save
        </PrimaryButton>
      </ModalActions>
    </KubitModal>
  );
};

export default ConfigureLumosModal;
